import type { ReactNode } from 'react';

interface StatCardProps {
  icon: ReactNode;
  value: string | number;
  label: string;
  variant?: 'default' | 'warning' | 'danger';
}

export function StatCard({ icon, value, label, variant = 'default' }: StatCardProps) {
  const valueColors = {
    default: 'text-primary-500',
    warning: 'text-yellow-400',
    danger: 'text-red-400',
  };

  return (
    <div className="stat-card">
      <div className="text-2xl mb-2">{icon}</div>
      <div className={`text-3xl font-bold ${valueColors[variant]}`}>{value}</div>
      <div className="text-sm text-gray-500 mt-1">{label}</div>
    </div>
  );
}
